// extracted by mini-css-extract-plugin
export default {"description":"styles_description__vG1-O","skipButton":"styles_skipButton__io6dy","videoIframe":"styles_videoIframe__-+kP0"};